<template lang="pug">
  v-stepper(v-model="e1")
    v-snackbar(
            v-model="snackbar"
            :timeout="10000"
            color='error'
    ) {{ snackbarMessage }}  
    v-stepper-header
      v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
      v-divider
      v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
      v-divider
      v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus

    v-stepper-items
      v-stepper-content(step="1")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              v-flex(xs4 sm3)
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Judul Pekerjaan
              v-flex(xs7 sm5)
                v-text-field(id="fip-judul-pekerjaan" class="inputDefault" v-model='judulPekerjaan' label="Judul Pekerjaan")
              v-flex(xs1 sm4)

              v-flex(xs3 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Tanggal Perizinan
              v-flex(xs4 sm2)
                v-menu(
                  v-model="startMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="startDate"
                      label="mulai dari"
                      prepend-icon="event"
                      readonly
                      id="fip-tgl-izin-start"
                      v-on="on")
                  v-date-picker(id="fip-tgl-izin-start-picker" v-model="startDate" @input="clearDate" :min="todayDate")
              v-flex(xs4 sm2)
                v-menu(
                  v-model="endMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="endDate"
                      label="sampai dengan"
                      prepend-icon="event"
                      readonly
                      id="fip-tgl-izin-end"
                      v-on="on")
                  v-date-picker(id="fip-tgl-izin-end-picker" v-model="endDate" @input="endMenu = false" :min="startDate")
              v-flex(xs1 sm4)
              
              v-flex(xs4 sm3)
                p(class="headerSection")
                  span(class="mustFill") *
                  span  Department
              v-flex(xs7 sm5)
                v-row
                  v-col
                    v-autocomplete(
                      class="inputDefault"
                      v-model="deptDivisi"
                      id="fip-dept-division"
                      :items="dataUsers.department"
                      label="Department")
                  v-col
                    v-text-field(id="fip-division" class="inputDefault" v-model='divisi' counter="100" maxlength="100" label="Divisi")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Lokasi Pekerjaan
              v-flex(xs7 sm5)
                v-row
                  v-col
                    v-autocomplete(
                        class="inputDefault"
                        label="Lokasi Pekerjaan" 
                        v-model="lokasi" 
                        :items="locations.data" 
                        no-data-text="No Data" 
                        color="blue-grey lighten-2" 
                        item-text="location_name" 
                        item-value="data"
                         id="fip-lokasi" 
                        clearable
                        chips
                        multiple)
                  v-col
                    v-text-field( id="fip-sub-lokasi" class="inputDefault" v-model='subLokasi' counter="100" maxlength="100" label="Sub Lokasi" height="42")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Perusahaan
              v-flex(xs7 sm5)
                v-autocomplete(
                  class="inputDefault"
                   id="fip-company"
                  v-model="perusahaan"
                  :items="dataUsers.companies"
                  label="Perusahaan")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Nama Pemegang Izin
              v-flex(xs7 sm5)
                v-menu(
                  v-model="searchPemegangMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="pemegangIzin.name"
                      label="Pemegang Izin"
                       id="fip-pemegang-izin"
                      readonly
                      v-on="on")
                  PemegangModal(:searchPemegang="searchPemegangMenu" @interface="searchPemegangMenu = false" @selectedUser="updatePemegangIzin")
              v-flex(xs1 sm4)
        v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="2")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              
              v-flex(xs12 sm12) 
                h3(class="headerSection") Lampiran Gambar Lokasi Penggalian
                br
  
              v-flex(xs3 sm3) 
                h4(class="headerSection") Jenis Instalasi / Saluran
                br
              v-flex(xs3 sm3) 
                h4(class="headerSection") Judul Gambar
                br
              v-flex(xs2 sm2) 
                h4(class="headerSection") Nomor Gambar
                br
              v-flex(xs3 sm3) 
                h4(class="headerSection") Diverifikasi Oleh
                br

              v-flex(xs3 sm3)
                p(class="headerInput") Instalasi Listrik
              v-flex(xs3 sm3)
                v-text-field(id="fip-instalasi-listrik"  class="fieldInput" v-model='instKblListrik' hint='Instalasi Listrik')
              v-flex(xs2 sm2)
                v-text-field(id="fip-instalasi-listrik"  class="fieldInput" v-model="noGbrKblListrik" hint='Instalasi Listrik') 
              v-flex(xs3 sm3)
                v-text-field(id="fip-instalasi-listrik" class="fieldInput" v-model='verifKblListrik' hint='Instalasi Listrik')

              v-flex(xs3 sm3)
                p(class="headerInput") Instalasi Telekomunikasi
              v-flex(xs3 sm3)
                v-text-field(id="fip-instalasi-telekomunikasi" class="fieldInput" v-model='instKblKomunikasi' hint='Instalasi Telekomunikasi')
              v-flex(xs2 sm2)
                v-text-field(id="fip-instalasi-telekomunikasi" class="fieldInput" v-model="noGbrKblKomunikasi" hint='Instalasi Telekomunikasi') 
              v-flex(xs3 sm3)
                v-text-field(id="fip-instalasi-telekomunikasi" class="fieldInput" v-model='verifKblKomunikasi' hint='Instalasi Telekomunikasi')

              v-flex(xs3 sm3)
                p(class="headerInput") Saluran Air Kotor
              v-flex(xs3 sm3)
                v-text-field(id="fip-saluran" class="fieldInput" v-model='instSalurAirKtr' hint='Saluran Air Kotor')
              v-flex(xs2 sm2)
                v-text-field(id="fip-saluran" class="fieldInput" v-model="noGbrSalurAirKtr" hint='Saluran Air Kotor') 
              v-flex(xs3 sm3)
                v-text-field(id="fip-saluran" class="fieldInput" v-model='verifSalurAirKtr' hint='Saluran Air Kotor')

              v-flex(xs3 sm3)
                p(class="headerInput") Instalasi Air Bersih
              v-flex(xs3 sm3)
                v-text-field(id="fip-instalasi-air-bersih" class="fieldInput" v-model='instPipaAirBrsh' hint='Instalasi Air Bersih')
              v-flex(xs2 sm2)
                v-text-field(id="fip-instalasi-air-bersih" class="fieldInput" v-model="noGbrPipaAirBrsh" hint='Instalasi Air Bersih') 
              v-flex(xs3 sm3)
                v-text-field(id="fip-instalasi-air-bersih" class="fieldInput" v-model='verifPipaAirBrsh' hint='Instalasi Air Bersih')
              
              v-flex(xs3 sm3)
                p(class="headerInput") Drainase Air
              v-flex(xs3 sm3)
                v-text-field(id="fip-drainase-air" class="fieldInput" v-model='instDrainBwhTnh' hint='Drainase Air')
              v-flex(xs2 sm2)
                v-text-field(id="fip-drainase-air" class="fieldInput" v-model="noGbrDrainBwhTnh" hint='Drainase Air') 
              v-flex(xs3 sm3)
                v-text-field(id="fip-drainase-air" class="fieldInput" v-model='verifDrainBwhTnh' hint='Drainase Air')

              v-flex(xs3 sm3)
                p(class="headerInput") Lainnya
              v-flex(xs3 sm3)
                v-text-field(id="fip-lainnya" class="fieldInput" v-model='instLainnya' hint='Lainnya')
              v-flex(xs2 sm2)
                v-text-field(id="fip-lainnya" class="fieldInput" v-model="noGbrLainnya" hint='Lainnya') 
              v-flex(xs3 sm3)
                v-text-field(id="fip-lainnya" class="fieldInput" v-model='verifLainnya' hint='Lainnya')

              v-flex(xs5 sm3) 
                h3(class="headerSection") Upload Dokumen
              v-flex(xs6 sm5 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
                v-file-input(id="fip-documen" :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                  template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="(docPendukung)||(docPendukung && docPendukung.size < 10000000)")
                span(id="fip-documen") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                  v-icon mdi-close
              v-flex(xs1 sm4)

              v-flex(xs12 sm12) 
                  h3(class="headerSection") Peralatan yang digunakan
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fip-peralatan" :editor="editor" v-model="peralatanYangDigunakan" :config="editorConfig")
                  br

              v-flex(xs12 sm12) 
                  h3(class="headerSection") Potensi Bahaya / Risiko Yang Mungkin Ada
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fip-potensi-bahaya" :editor="editor" v-model="bahaya" :config="editorConfig")

        v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
        v-btn(color="primary" @click="e1 = 3; scrollTop();") Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="3")
        v-card(class="mb-12"
        height="auto")
          v-layout(row wrap)
              v-flex(xs12 sm12) 
                p(class="headerSection") Daftar Periksa
              v-flex(xs5 sm6)
                p(class="headerInput") Prosedur kerja (PPO / AKA) ada?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fip-prosedur-kerja" class="selectInput" :items='checkOptions' v-model="ppoAka" label="Pilih" clearable) 

              v-flex(xs5 sm6)
                p(class="headerInput") Personil telah kompeten bekerja di penggalian?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fip-personil" class="selectInput" :items='checkOptions' v-model="kompeten" label="Pilih" clearable) 
              
              v-flex(xs5 sm6)
                p(class="headerInput") Area kerja sudah dibarrikade?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fip-area-kerja" class="selectInput" :items='checkOptions' v-model="barikade" label="Pilih" clearable) 

              v-flex(xs5 sm6)
                p(class="headerInput") Apakah ada peta jalur kabel/pipa
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fip-peta-jalur" class="selectInput" :items='checkOptions' v-model="petaJalurKabel" label="Pilih" clearable) 

              v-flex(xs12 sm12) 
                  h3(class="headerSection") Pengendalian Risiko Tambahan
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fip-pengendalian-resiko" :editor="editor" v-model="pengendalianRisikoTambahan" :config="editorConfig")
                  br
              
              v-flex(xs12 sm12) 
                  h3(class="headerSection") Catatan Penting Lainnya
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fip-catatan" :editor="editor" v-model="catatanPentingLain" :config="editorConfig")
                  br

        v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
        v-btn(class="mr-3" color='info' @click='submit(1)')
          v-icon insert_drive_file
          | &nbsp; Save as Draft
        v-btn(color='success' @click='submit(2)')
          v-icon send
          | &nbsp; Submit Request
        v-btn(text @click="backHome()") Cancel
</template>

<script>
// import * as config from "../config/index.json";
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
import PemegangModal from "./PemegangModal.vue";
import { handleError } from "../helper/handleGlobalError.js";
export default {
  name: "AddIzinPenggalian",
  components: {
    PemegangModal,
  },
  props: {
    edit: { type: Boolean, default: false },
    syncLocations: Array,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        removePlugins: ["ImageUpload", "MediaEmbed"],
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
        image: {
          // You need to configure the image toolbar, too, so it uses the new style buttons.
          toolbar: [
            "imageTextAlternative",
            "|",
            "imageStyle:alignLeft",
            "imageStyle:full",
            "imageStyle:alignRight",
          ],
          styles: [
            // This option is equal to a situation where no style is applied.
            "full",
            // This represents an image aligned to the left.
            "alignLeft",
            // This represents an image aligned to the right.
            "alignRight",
          ],
        },
      },
      e1: 1,
      formCode: "BIB-HSE-PPO-FRM-036-004",
      todayDate: new Date().toISOString().slice(0, 10),
      judulPekerjaan: "",
      deptDivisi: "",
      divisi: "",
      perusahaan: "",
      pemegangIzin: "",
      lokasi: [],
      subLokasi: '',

      searchPemegangMenu: false,
      uploadId: null,
      docPendukung: null,
      startMenu: false,
      startDate: "",
      endMenu: false,
      endDate: "",
      startDateExtend: new Date().toISOString().substr(0, 10),
      endDateExtend: new Date().toISOString().substr(0, 10),
      startMenuExtend: false,
      endMenuExtend: false,

      checkOptions: ["Ya", "Tidak"],
      instKblListrik: "",
      noGbrKblListrik: "",
      verifKblListrik: "",

      instKblKomunikasi: "",
      noGbrKblKomunikasi: "",
      verifKblKomunikasi: "",

      instSalurAirKtr: "",
      noGbrSalurAirKtr: "",
      verifSalurAirKtr: "",

      instPipaAirBrsh: "",
      noGbrPipaAirBrsh: "",
      verifPipaAirBrsh: "",

      instDrainBwhTnh: "",
      noGbrDrainBwhTnh: "",
      verifDrainBwhTnh: "",

      instLainnya: "",
      noGbrLainnya: "",
      verifLainnya: "",

      ppoAka: "",
      kompeten: "",
      barikade: "",
      petaJalurKabel: "",

      pengendalianRisikoTambahan: "",
      catatanPentingLain: "",
      peralatanYangDigunakan: "",
      bahaya: "",
      snackbarMessage: "",

      status: 0,
      rules: [
        (value) =>
          !value || value.size < 10000000 || "Ukuran file harus dibawah 10 MB!",
      ],
      emptyUpload: new File([""], "", {
        type: "",
      }),
    };
  },
  mounted: async function () {
    this.$store.dispatch("fetchLocations");
    this.uploadId = Date.now();
  },
  computed: {
    ...mapState([
      "API_URL",
      "locations",
      "dataUsers",
      "dataEditRequest"
    ]),
    selectedLoc() {
      let tempLoc = [];
      let locationCode;

      if (this.dataUsers.location instanceof Array) {
        locationCode = this.dataUsers.location[0];
      } else {
        locationCode = this.dataUsers.location;
      }

      for (let i = 0; i < this.lokasi.length; i++) {
        tempLoc.push({ code: locationCode, name: this.lokasi[i] });
      }
      return tempLoc;
    },
    isPage1Complete: function () {
      return (
        !!this.judulPekerjaan &&
        !!this.deptDivisi &&
        !!this.divisi &&
        !!this.subLokasi &&
        !!this.perusahaan &&
        this.selectedLoc.length != 0 &&
        !!this.pemegangIzin &&
        !(this.selectedLoc.length < 1) &&
        !!this.startDate &&
        !!this.endDate
      );
    },
  },
  methods: {
    updatePemegangIzin(user) {
      this.pemegangIzin = user;
    },
    clearDate() {
      this.endDate = null;
      this.startMenu = false;
    },
    formatDate: helper.formatDate,
    scrollTop() {
      window.scrollTo(0, 0);
    },
    submit(status) {
      // this.submitClick = true;
      this.status = status;

      let formData = new FormData();
      if (this.edit) {
        formData.append("_id", this.dataEditRequest._id);
        formData.append("ipNo", this.dataEditRequest.ipNo);
        formData.append(
          "ipWorkflow",
          JSON.stringify(this.dataEditRequest.ipWorkflow)
        );
      }

      formData.append("ipPemegangIzin", JSON.stringify(this.pemegangIzin));
      // formData.append('ipNomorIzinKerja', this.nomorIzinKerja);
      formData.append("ipLocation", JSON.stringify(this.selectedLoc));
      formData.append("ipSubLokasi", this.subLokasi);
      formData.append("ipJudulPekerjaan", this.judulPekerjaan);
      formData.append("ipDeptDivisi", this.deptDivisi);
      formData.append("ipDivisi", this.divisi);

      formData.append("ipInstKblListrik", this.instKblListrik);
      formData.append("ipNoGbrKblListrik", this.noGbrKblListrik);
      formData.append("ipVerifKblListrik", this.verifKblListrik);

      formData.append("ipInstKblKomunikasi", this.instKblKomunikasi);
      formData.append("ipNoGbrKblKomunikasi", this.noGbrKblKomunikasi);
      formData.append("ipVerifKblKomunikasi", this.verifKblKomunikasi);

      formData.append("ipInstSalurAirKtr", this.instSalurAirKtr);
      formData.append("ipNoGbrSalurAirKtr", this.noGbrSalurAirKtr);
      formData.append("ipVerifSalurAirKtr", this.verifSalurAirKtr);

      formData.append("ipInstPipaAirBrsh", this.instPipaAirBrsh);
      formData.append("ipNoGbrPipaAirBrsh", this.noGbrPipaAirBrsh);
      formData.append("ipVerifPipaAirBrsh", this.verifPipaAirBrsh);

      formData.append("ipInstDrainBwhTnh", this.instDrainBwhTnh);
      formData.append("ipNoGbrDrainBwhTnh", this.noGbrDrainBwhTnh);
      formData.append("ipVerifDrainBwhTnh", this.verifDrainBwhTnh);

      formData.append("ipInstLainnya", this.instLainnya);
      formData.append("ipNoGbrLainnya", this.noGbrLainnya);
      formData.append("ipVerifLainnya", this.verifLainnya);

      formData.append("ipPpoAka", this.ppoAka);
      formData.append("ipKompeten", this.kompeten);
      formData.append("ipBarikade", this.barikade);
      formData.append("ipPetaJalurKabel", this.petaJalurKabel);

      formData.append(
        "ipPengendalianRisikoTambahan",
        this.pengendalianRisikoTambahan
      );
      formData.append("ipCatatanPentingLain", this.catatanPentingLain);
      formData.append("ipPeralatanYangDigunakan", this.peralatanYangDigunakan);
      formData.append("ipBahaya", this.bahaya);

      formData.append("ipStatus", this.status);
      formData.append("ipPerusahaan", this.perusahaan);
      formData.append("ipPelaksanaanStart", this.startDate);
      formData.append("ipPelaksanaanEnd", this.endDate);

      formData.append("uploadId", this.uploadId);
      formData.append("ipUser", JSON.stringify(this.dataUsers));
      formData.append("ipForm", this.formCode);
      const config = {
        method: this.edit ? "put" : "post",
        url: `${this.API_URL}/v1/requests`,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: formData,
      };
      axios(config).then((res) => {
        this.$store.commit("temporaryData", res);
        this.$router.push("/my-permit");
      }).catch(error => {
        handleError(error, {
          setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
          showSnackbar: (show) => { this.snackbar = show; },
          disableLoader: () => {
            this.$store.state.loader = false;
          },
        });
        this.submitClick = false;
      });
    },
    upload(name, paramFile) {
      if (paramFile == undefined) return;
      if (paramFile.size > 10000000) {
        paramFile = null;
        if (name == "docPendukung") {
          this.docPendukung = this.emptyUpload;
        }
        return;
      } else {
        let formData = new FormData();
        formData.append("uploadId", this.uploadId);
        formData.append(name, paramFile);
        axios.post(`${this.API_URL}/v1/requests/attachment/${name}`, formData, {
          headers: { Authorization: `Bearer ${this.$store.state.token}` },
        });
      }
    },
    deleteDocPendukung(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    backHome() {
      this.$router.push("/my-permit");
    },
    backStep() {
      this.e1--;
    },
    docName(name) {
      return this.$setFilename(name);
    },
  },
  watch: {
    docPendukung(params){
      if(params && params.size < 10000000){
         let formData = new FormData();
        formData.append('uploadId', this.uploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      }
    },
    dataEditRequest: async function () {
      this.perusahaan = this.dataEditRequest.ipPerusahaan;
      // for (const item of this.locations) {
      //   let checked = false
      //   for (const element of this.dataEditRequest.ipLocation) {
      //     if(item.name == element.name) checked = true
      //   }
      //   if(checked) this.lokasi.push(true)
      //   else this.lokasi.push(false)
      // }
      this.lokasi = [];
      for (const loc of this.dataEditRequest.ipLocation) {
        this.lokasi.push(loc.name);
      }
      this.subLokasi = this.dataEditRequest.ipSubLokasi;
      this.pemegangIzin = this.dataEditRequest.ipPemegangIzin;
      this.judulPekerjaan = this.dataEditRequest.ipJudulPekerjaan;
      this.deptDivisi = this.dataEditRequest.ipDeptDivisi;
      this.divisi = this.dataEditRequest.ipDivisi;

      this.instKblListrik = this.dataEditRequest.ipInstKblListrik;
      this.noGbrKblListrik = this.dataEditRequest.ipNoGbrKblListrik;
      this.verifKblListrik = this.dataEditRequest.ipVerifKblListrik;

      this.instKblKomunikasi = this.dataEditRequest.ipInstKblKomunikasi;
      this.noGbrKblKomunikasi = this.dataEditRequest.ipNoGbrKblKomunikasi;
      this.verifKblKomunikasi = this.dataEditRequest.ipVerifKblKomunikasi;

      this.instSalurAirKtr = this.dataEditRequest.ipInstSalurAirKtr;
      this.noGbrSalurAirKtr = this.dataEditRequest.ipNoGbrSalurAirKtr;
      this.verifSalurAirKtr = this.dataEditRequest.ipVerifSalurAirKtr;

      this.instPipaAirBrsh = this.dataEditRequest.ipInstPipaAirBrsh;
      this.noGbrPipaAirBrsh = this.dataEditRequest.ipNoGbrPipaAirBrsh;
      this.verifPipaAirBrsh = this.dataEditRequest.ipVerifPipaAirBrsh;

      this.instDrainBwhTnh = this.dataEditRequest.ipInstDrainBwhTnh;
      this.noGbrDrainBwhTnh = this.dataEditRequest.ipNoGbrDrainBwhTnh;
      this.verifDrainBwhTnh = this.dataEditRequest.ipVerifDrainBwhTnh;

      this.instLainnya = this.dataEditRequest.ipInstLainnya;
      this.noGbrLainnya = this.dataEditRequest.ipNoGbrLainnya;
      this.verifLainnya = this.dataEditRequest.ipVerifLainnya;

      this.ppoAka = this.dataEditRequest.ipPpoAka;
      this.kompeten = this.dataEditRequest.ipKompeten;
      this.barikade = this.dataEditRequest.ipBarikade;
      this.petaJalurKabel = this.dataEditRequest.ipPetaJalurKabel;

      this.pengendalianRisikoTambahan =
        this.dataEditRequest.ipPengendalianRisikoTambahan;
      this.catatanPentingLain = this.dataEditRequest.ipCatatanPentingLain;
      this.peralatanYangDigunakan =
        this.dataEditRequest.ipPeralatanYangDigunakan;
      this.bahaya = this.dataEditRequest.ipBahaya;

      this.startDate = this.formatDate(
        this.dataEditRequest.ipPelaksanaanStart
      ).slice(0, 10);
      this.endDate = this.formatDate(
        this.dataEditRequest.ipPelaksanaanEnd
      ).slice(0, 10);
      this.uploadId = this.dataEditRequest.uploadId;
      this.docPendukung = this.dataEditRequest.ipAttachmentFiles.docPendukung;
    },
  },
};
</script>

<style>
.ck-editor__editable {
  min-height: 300px;
  max-height: 300px;
  resize: none;
}

.mustFill {
  color: #ea5164;
}
</style>
